import { compact } from 'lodash/fp'
import _ from 'lodash'
import BIMESSAGES from 'core/data-model/constants/bi-messages'
import VALUES from 'core/data-model/constants/values'

import LegalDisclaimerMarketConduct from 'quick-quote/product-common/benefit-illustration/components/legal-disclaimer-market-conduct'
import { LegalConditionDisclaimerMarketConductNoAddtionalContract } from 'quick-quote/v2/components/disclaimers'
import ProfileSnapshot from 'quick-quote/product-common/benefit-illustration/components/profile-summary/profile-snapshot'
import ProductBenefits from 'quick-quote/product-whole-life/benefit-illustration/components/product-benefits/product-benefits'
import RiderBenefits from 'quick-quote/product-common/benefit-illustration/components/rider-benefits'
import PolicyValueTable from 'quick-quote/v2/components/benefit-illustration/policy-values/layout-for-12pl/policy-value-table'
import BenefitSummaryTable from './components/benefit-summary-table'
import TaxConsentDeductionBenefit from 'quick-quote/product-common/benefit-illustration/components/tax-consent-deduction-benefit'

import { getProfileSnapshot } from 'quick-quote/product-common/benefit-illustration/components/profile-summary/selectors'
import {
  getLegalDisclaimerEndDate,
  getTaxDeduction,
} from 'quick-quote/product-whole-life/benefit-illustration/selectors'
import { getcoveragePlanStartDate, getSelectedRiders } from 'quick-quote/product-common/coverage-plan/selectors'
import { getProductBenefits } from 'quick-quote/product-whole-life/benefit-illustration/components/product-benefits/selectors'
import { getPolicyValueTableBenefits } from 'quick-quote/product-whole-life/benefit-illustration/components/policy-value/selectors'
import { getSelectedDisplayProduct, getSelectedDisplayProductCode } from 'quick-quote/product-selection/selectors'
import { getDisplayBenefitSummaryTable } from './components/benefit-summary-table/selectors'

const _summaryHeaderWithCode = ({ displayProduct, riders }) => {
  const name = [VALUES.CODE_12PL_SIO, VALUES.CODE_12PL_GIO].includes(displayProduct.code)
    ? `${_.get(displayProduct, 'nameThai', '')} (${_.get(displayProduct, 'basicPlanCode', '')})`
    : _.get(displayProduct, 'displayName', '')
  return `${name}`
}

const _summaryHeader = ({ displayProduct }) => {
  if (displayProduct) {
    const productCode = _.get(displayProduct, 'code', '')
    return [VALUES.CODE_12PL_SIO, VALUES.CODE_12PL_GIO].includes(productCode)
      ? `${displayProduct.nameThai} (${displayProduct.basicPlanCode})`
      : displayProduct.displayName
  } else return ''
}

export const getSections = (state) => {
  const riders = getSelectedRiders(state)
  const productCode = getSelectedDisplayProductCode(state)
  return compact([
    {
      component: ProfileSnapshot,
      props: {
        ...getProfileSnapshot(state),
        profileSummaryHeader: _summaryHeaderWithCode,
        summaryTableHeader: _summaryHeader,
      },
    },
    {
      component: ProductBenefits,
      props: getProductBenefits(state),
    },
    riders.length > 0 && {
      component: RiderBenefits,
    },
    {
      component: PolicyValueTable,
      props: getPolicyValueTableBenefits(state),
    },
    {
      component: BenefitSummaryTable,
      props: getDisplayBenefitSummaryTable(state),
    },
    {
      component: TaxConsentDeductionBenefit,
      props: {
        taxDeduction: getTaxDeduction(state),
      },
    },
    {
      component: [VALUES.CODE_12PL_SIO, VALUES.CODE_12PL_GIO].includes(productCode)
        ? LegalConditionDisclaimerMarketConductNoAddtionalContract
        : LegalDisclaimerMarketConduct,
      props: {
        startDate: getcoveragePlanStartDate(state),
        endDate: getLegalDisclaimerEndDate(state),
      },
    },
  ])
}

export const getMenus = (state) => {
  const selectedDisplayProduct = getSelectedDisplayProduct(state)
  return compact([
    {
      text: selectedDisplayProduct?.riders?.length
        ? BIMESSAGES.SUMMARY_OF_MAIN_AND_ADDITIONAL_CONTRACTS
        : BIMESSAGES.SUMMARY_OF_MAIN_CONTRACTS,
      id: 'profile-summary',
      isSub: false,
    },
    {
      text: 'รายละเอียดของสัญญาหลัก',
      id: 'product-benefits',
      isSub: false,
    },
    {
      text: BIMESSAGES.POLICY_VALUE_TABLE,
      id: 'policy-value',
      isSub: false,
    },
    {
      text: BIMESSAGES.INVESTMENT_BENEFITS,
      id: 'summary-benefit',
      isSub: false,
    },
    {
      text: BIMESSAGES.LEGAL_DISCLAIMER,
      id: 'legal-disclaimer-market-conduct',
      isSub: false,
    },
  ])
}
